import { memo } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from "@cointervue/design-system";
import { TableSkeleton } from "@/components"; // Assuming alias resolves to components folder

function ApplicantsPageSkeleton() {
  return (
    <div className="bg-brand-light-orange h-full p-4 overflow-y-auto space-y-2">
      {/* Job Detail Card Skeleton */}
      <Card className="py-4 px-6 mx-4 mb-3 animate-pulse">
        <CardHeader className=" flex-col text-center space-y-3 p-3">
          <div className="bg-gray-200 rounded w-48 h-6 mb-2" />
          <div className="bg-gray-200 rounded w-64 h-4 mb-2" />
          <div className="bg-gray-200 rounded w-28 h-6 mb-2" />
        </CardHeader>
        <CardContent className="space-y-3 my-1">
          <div className="bg-gray-200 rounded w-full h-10 mb-2" />
          <div className="bg-gray-200 rounded w-full h-8 mb-2" />
        </CardContent>
        <CardFooter className="flex-col space-y-3">
          <div className="bg-gray-200 rounded w-full h-8" />
        </CardFooter>
      </Card>
      {/* Search Skeleton */}
      <div className="p-4 mx-2 sm:mx-4 mb-3 card-base animate-pulse">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
          {/* Input skeleton */}
          <div className="w-full sm:flex-1 sm:max-w-md h-8 bg-gray-200 rounded" />
          {/* Filter dropdown skeleton */}
          <div className="w-full sm:w-24 h-8 bg-gray-200 rounded" />
        </div>
      </div>
      {/* Candidates Table Skeleton */}
      <div className="w-full overflow-x-auto">
        <div className="min-w-[900px]">
          <TableSkeleton columns={5} rows={6} />
        </div>
      </div>
    </div>
  );
}

export default memo(ApplicantsPageSkeleton);
